import {
    NgModule,
} from '@angular/core';

import {
    RouterModule,
    Routes,
} from '@angular/router';

import {
    ErrorComponent,
} from './ui/containers/error/error.component';


export const routes: Routes = [
    {
        path: '',
        component: ErrorComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ProblemsRoutingModule { }
